var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 将音频channel解析为可读符号
 */
export function parseAudioChannel(channel) {
    let ch;
    switch (channel) {
        case 8:
            ch = '7.1Ch';
            break;
        case 6:
            ch = '5.1Ch';
            break;
        case 2:
            ch = 'Stereo';
            break;
        case 1:
            ch = 'Mono';
            break;
        default:
            ch = `${channel}Ch`;
            break;
    }
    return ch;
}
export function redirectHLSV3(url) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield fetch(url);
        if (res.ok && res.status >= 200 && res.status <= 299) {
            const text = yield res.text();
            const tagList = text.split('\n');
            if (tagList.findIndex(tag => tag === '#EXTM3U') > -1 &&
                tagList.findIndex(tag => tag === '#EXT-X-VERSION:3') > -1) {
                const index = tagList.findIndex(tag => tag.startsWith('#EXT-X-STREAM-INF'));
                if (index !== -1)
                    return (_a = tagList[index + 1]) !== null && _a !== void 0 ? _a : url;
            }
        }
        return url;
    });
}
//# sourceMappingURL=video-utils.js.map